import { SetNewPasswordComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const SetNewPasswordPandit = () => {
	return <SetNewPasswordComponent signInLink={APP_ROUTES.SIGN_IN_USER} />;
};

export default SetNewPasswordPandit;
